var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContentOrLoading',[(!_vm.loadingButacas)?_c('div',{staticClass:"card card-body card-outline card-outline-tabs"},[_c('PorPlanoButaca',{attrs:{"plazas":_vm.butacas,"recinto_id":_vm.evento.place_id,"evento":_vm.evento},on:{"recargar":_vm.getButacas}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }